import { siteConfig } from '@/config/site'

export const absoluteUrl = (pathOrUrl: string, baseUrl = siteConfig.siteUrl) => {
  if (/^https?:\/\//i.test(pathOrUrl)) {
    return pathOrUrl
  }

  const path = pathOrUrl.startsWith('/') ? pathOrUrl : `/${pathOrUrl}`
  return `${baseUrl.replace(/\/+$/, '')}${path}`
}

export const articlePath = (slug: string) => `/blog/${slug}`
